const defaultThemeVariables = {
    footer__navIcon: 'angle',
    footer__sectionPartPrefix: false,
    footer__tocButtonIcon: 'fa-list-ol',
    gapMatchExtended__supportsSplitScrolling: false,
    header__hidePreloadCaption: false,
    header__logoPath: null,
    header__optionsAnchorIcon: 'fa-bars',
    header__showMessagesButton: true,
    header__showSkipLink: true,
    header__sideBarIcon: 'fa-pencil-square-o',
    options__fileDeliveryIcon: 'fa-unlock-alt',
    options__moveFileDeliveryToInvigilator: false,
    question__displayTokensVertically: false,
    question__showCopyrightText: false,
    question__showMarksInBrackets: false,
    question__wideAndLeftAlign: false,
    rubric__showDynamicRubric: false,
    rubric__showQuestionRubric: false,
    rubric__showSectionRubric: false,
    scorableItemsDash: '-',
    stimulus__showMargins: true,
    submit__showSubmitIcon: true,
    toc__showFlaggedText: false,
    toc__tableHeaderOnEachTBody: true,
};

export default defaultThemeVariables;
